
import { supabase } from '@/integrations/supabase/client';

export interface BlockedDate {
  id?: string;
  mentor_id: string;
  date: string;
  reason?: string;
}

export const getBlockedDates = async (mentorId: string) => {
  try {
    const { data, error } = await supabase
      .from('mentor_blocked_dates')
      .select('*')
      .eq('mentor_id', mentorId)
      .order('date');

    if (error) throw error;
    return { success: true, data };
  } catch (error) {
    console.error('Error fetching blocked dates:', error);
    return { success: false, error };
  }
};

export const addBlockedDate = async (blockedDate: BlockedDate) => {
  try {
    const { error } = await supabase
      .from('mentor_blocked_dates')
      .insert(blockedDate);

    if (error) throw error;
    return { success: true };
  } catch (error) {
    console.error('Error adding blocked date:', error);
    return { success: false, error };
  }
};

export const removeBlockedDate = async (id: string) => {
  try {
    const { error } = await supabase
      .from('mentor_blocked_dates')
      .delete()
      .eq('id', id);

    if (error) throw error;
    return { success: true };
  } catch (error) {
    console.error('Error removing blocked date:', error);
    return { success: false, error };
  }
};
